import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { BASIC_COMPONENT_FIELDS, CMS_COMPONENT_CWV_CONFIG } from '../../../../config/component.config';

export default <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: 'feature-banner-v2',
    name: 'Feature Banner 2',
    image: 'assets/images/cms/feature-banner-v2.png',
    tags: ['Homepage', 'Banner', 'Video'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'component_ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Whole component ratio',
            options: RatioOptions,
            description: 'Ratio of whole component',
            default: 'ratio-8-9',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'reverse',
            type: NICmsContentField.EFieldType.choice,
            title: 'Layout',
            description: 'Position of images',
            default: 'left',
            options: [
                { key: 'left,', title: 'Full-size image on left' },
                { key: 'right', title: 'Full-size image on right' }
            ]
        },
        <NICmsContentField.IChoiceField>{
            key: 'images_gallery_option',
            type: NICmsContentField.EFieldType.choice,
            title: 'Images gallery option',
            required: true,
            default: 'image',
            options: [
                { key: 'two_top_one_bottom', title: 'Two portrait images at the top and one landscape image at the bottom' },
                { key: 'one_top_two_bottom', title: 'One landscape image at the top and two portrait images at the bottom' },
                { key: 'one_top_one_bottom', title: 'One landscape image at the top and one landscape image at the bottom' },
                { key: 'two_top_two_bottom', title: 'Two portrait images at the top and two portrait images at the bottom' }
            ]
        },
        <NICmsContentField.IChoiceField>{
            key: 'padding',
            type: NICmsContentField.EFieldType.choice,
            title: 'Padding',
            required: true,
            default: 'no_padding',
            options: [
                { key: 'with_padding', title: 'Padding' },
                { key: 'no_padding', title: 'No padding' }
            ]
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'full-size-image',
            title: 'Full-size image'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'full_s_image',
            title: 'Image',
            default: ''
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'full_s_video_id',
            title: 'Video',
            description: 'Video ID or URL, e.g. https://vimeo.com/442627127'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'full_s_button_label',
            title: 'Button label',
            default: 'Find out more'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'full_s_link',
            title: 'Link',
            default: '/'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'gallery-image-1',
            title: 'Gallery image 1'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image_1',
            title: 'Image',
            default: ''
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'video_id_1',
            title: 'Video',
            description: 'Video ID or URL, e.g. https://vimeo.com/442627127'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'button_label_1',
            title: 'Button label',
            default: 'Find out more'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'link_1',
            title: 'Link',
            default: '/'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'gallery-image-2',
            title: 'Gallery image 2',
            canShow: data => data?.images_gallery_option === 'two_top_one_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image_2',
            title: 'Image',
            default: '',
            canShow: data => data?.images_gallery_option === 'two_top_one_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'video_id_2',
            title: 'Video',
            description: 'Video ID or URL, e.g. https://vimeo.com/442627127',
            canShow: data => data?.images_gallery_option === 'two_top_one_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'button_label_2',
            title: 'Button label',
            default: 'Find out more',
            canShow: data => data?.images_gallery_option === 'two_top_one_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'link_2',
            title: 'Link',
            default: '/',
            canShow: data => data?.images_gallery_option === 'two_top_one_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'gallery-image-3',
            title: 'Gallery image 3'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image_3',
            title: 'Image',
            default: ''
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'video_id_3',
            title: 'Video',
            description: 'Video ID or URL, e.g. https://vimeo.com/442627127'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'button_label_3',
            title: 'Button label',
            default: 'Find out more'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'link_3',
            title: 'Link',
            default: '/'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'gallery-image-4',
            title: 'Gallery image 4',
            canShow: data => data?.images_gallery_option === 'one_top_two_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image_4',
            title: 'Image',
            default: '',
            canShow: data => data?.images_gallery_option === 'one_top_two_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'video_id_4',
            title: 'Video',
            description: 'Video ID or URL, e.g. https://vimeo.com/442627127',
            canShow: data => data?.images_gallery_option === 'one_top_two_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'button_label_4',
            title: 'Button label',
            default: 'Find out more',
            canShow: data => data?.images_gallery_option === 'one_top_two_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'link_4',
            title: 'Link',
            default: '/',
            canShow: data => data?.images_gallery_option === 'one_top_two_bottom' || data?.images_gallery_option === 'two_top_two_bottom'
        },
        ...BASIC_COMPONENT_FIELDS,
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
